import React, { useState } from 'react';
import Header from '../Header';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Card, Row, Col, Alert } from 'react-bootstrap'; // Importing React-Bootstrap components
import './index.css';

const Manager = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: '',
    role: '', // default type is Manager
  });

  const navigate = useNavigate();

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, password, phone, role } = formData;

    const newEmployee = { name, email, password, phone, role };

    try {
      const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/manager', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newEmployee),
      });

      if (response.ok) {
        setSuccess('Manager added successfully');
        setFormData({
          name: '',
          email: '',
          password: '',
          phone: '',
          role: '', // reset managerType after submission
        });
        setError('');
      } else {
        setError('Failed to add Manager. Please try again.');
      }
    } catch (error) {
      setError('An error occurred. Please try again later.');
    }
  };

  return (
    <>
      <Header />
      <div className='container-fluid'>
        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}
        <Card className="shadow">
          <Card.Header>
            <h2>
              Add Manager &nbsp;
              <Button variant="primary" className="float-right" onClick={() => navigate('/mlist')}>
                Managers List
              </Button>
            </h2>
          </Card.Header>

          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6} className="mb-3">
                  <Form.Label htmlFor="name">Name</Form.Label>
                  <Form.Control
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Enter Manager Name"
                    required
                  />
                </Col>

                <Col md={6} className="mb-3">
                  <Form.Label htmlFor="email">Email</Form.Label>
                  <Form.Control
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter Manager Email"
                    required
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6} className="mb-3">
                  <Form.Label htmlFor="password">Password</Form.Label>
                  <Form.Control
                    type="password"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    placeholder="Enter Password"
                    required
                  />
                </Col>

                <Col md={6} className="mb-3">
                  <Form.Label htmlFor="phone">Phone</Form.Label>
                  <Form.Control
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Enter Phone Number"
                    required
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6} className="mb-3">
                  <Form.Label htmlFor="role">Manager Type</Form.Label>
                  <Form.Control
                    as="select"
                    id="role"
                    name="role"
                    value={formData.role}
                    onChange={handleInputChange}
                    required
                  >
                    <option value=''>-- Select Manager --</option>
                    <option value="manager">Manager</option>
                    <option value="sale manager">Sales Manager</option>
                  </Form.Control>
                </Col>
              </Row>

              <div className="text-center">
                <Button type="submit" variant="primary">Submit</Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default Manager;
